import _ from "lodash"
import moment from "utils/moment"
import qs from "qs"
import { defaultInstance } from "services"
import { removeEmpty } from "utils"
import { responseError, responseSuccess } from "utils/response"

export const incidentReport = async (req,file) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file',file);
    const params = removeEmpty(req)
    const config = {
        method: 'post',
        url: 'api/v1/report/incident?locale=en_EN&file_format=pdf',
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        },
        data: bodyFormData,
        responseType: 'blob'
    }
  try {
    const {data,headers,status} = await defaultInstance.request(config); 
    const filename = headers['content-disposition']?.split(';')[1].split('=')[1].replace('"', '').replace('"', '') || `report_incident_${moment().format('YYYYMMDD')}_${moment().format('hhmmss')}.pdf`;
    if(status !== 200) {
        return responseError({ message: 'API something went wrong' })
    }
    return responseSuccess({data: {
      file :data,
      filename: filename
    }})
     
  } catch (err) {
    if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
  }
}
